module.exports = __webpack_public_path__ + "img/add.35e4dba8.svg";